import { CanActivate, GuardResult, MaybeAsync } from "@angular/router";
import { hideAppLoader } from "src/app/support/app-loader";

export class HideAppLoaderGuard implements CanActivate {
  canActivate(): MaybeAsync<GuardResult> {
    hideAppLoader();

    return true;
  }
}
